<template>
    <div class="speech-evalution">
        <span class="evaluate">{{msg}}</span>
        <div class="head">
            <Avatar></Avatar>
        </div>
        <div class="voice-play">
            <VoicePlayer :url="VoiceUrl" type='evaluate' :time="time"></VoicePlayer>
        </div>
    </div>
</template>

<script>
    import Avatar from './Avatar.vue'
    import VoicePlayer from './VoicePlayer.vue'

    export default {
        components: {Avatar, VoicePlayer},
        props: {
            value: null,
            VoiceUrl: '',
            time: ''
        },
        data: function () {
            return {
                msg: '语音题目评价'
            }
        },
        created () {
            if (this.value === 1) {
                this.msg = '语音题目评价'
            } else if (this.value === 2) {
                this.msg = '选择题目评价'
            } else {
                this.msg = '课堂评价'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .speech-evalution {
        .evaluate {
            font-size: 14px;
            color: #aaa;
        }
        .head {
            display: inline-block;
        }
        .voice-play {
            display: inline-block;
            height: 40px;
            width: 150px;
            margin: -15px 0;
            vertical-align: middle;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/SpeechEvaluation.vue